<div
  class="tw-bg-gray-200 tw-rounded-3 tw-relative tw-overflow-hidden tw-shadow-z4"
  [class.tw-mx-4]="!margin()"
  [class.tw-p-4]="!padding()"
  [class.tw-pt-9]="!padding()"
  [style.padding]="padding()"
  [style.margin]="margin()">
  <ng-content select="[slot=header]"></ng-content>
  <div class="tw-bg-gray-100 tw-p-4 tw-pl-2 tw-rounded-[10px] tw-relative tw-flex tw-items-center tw-shadow-sm tw-border tw-gap-2">
    <div class="tw-flex-shrink-0">
      <img class="tw-h-12 tw-w-12" src="/assets/gifs/sand-watch-loader-gray-bg.gif" alt="loader" class="tw-w-12 tw-aspect-square"/>
    </div>
    <ng-content select="[slot=sub-header]"></ng-content>
    <div class="tw-absolute tw-right-0 tw-bottom-0">
      <ng-content select="[slot=doctor-image]"></ng-content>
    </div>
  </div>
</div>
